import Model, { attr } from '@ember-data/model';

export default class Notification extends Model {
  @attr() emailTo; // array of email addresses
  @attr() fundIds; // array of fund ids in the string format
  @attr() excludeEventTypeIds; // array of integers
  @attr('boolean') notifySameDayOnNewTransactions;
  @attr('boolean') includeContactCityAndState;
  @attr('boolean') includeContactEmail;
  @attr('boolean') notifyUpcomingTasks;
}
